import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import config from '../../config';
import NumberUtils from '../../utils/NumberUtils';
import { DeleteModal } from './DeleteModal';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import { PotDetailMessages } from './PotDetailMessages';
import { CircularProgress } from './CircularProgress';
import InternetBankingActions from '../../actions/InternetBankingActions';
import BrowserUtils from '../../utils/BrowserUtils';
import MobileOverlay from '../common/MobileOverlay';
import SiteHeader from '../../includes/SiteHeader';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import AnyQuestions from '../help/AnyQuestions';

class SavingPotDetail extends Component {
  constructor(props) {
    super(props);

    this.getHeaderClass = this.getHeaderClass.bind(this);
    this.editPot = this.editPot.bind(this);
    this.handleMoveMoney = this.handleMoveMoney.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.smClose = this.smClose.bind(this);
    this.smShow = this.smShow.bind(this);
    this.closeFaq = this.closeFaq.bind(this);
    this.openFaq = this.openFaq.bind(this);

    this.state = {
      showModal: false,
      faqFlag: false,
    };
  }

  componentDidMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
  }

  getHeaderClass(e) {
    this.setState({ headerClass: e });
  }

  editPot() {
    SavingPotsActionCreator.getCreateSavingPotPage(this.props.potDetailsData);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_saving_goal_edit_edit_goal,
        event: 'click',
      }
    );
  }

  handleMoveMoney() {
    //  - Move money - transfer to payment page
    const data = {
      id: this.props.getSelectedAccountID,
      potId: this.props.potDetailsData.id,
      amt: 0,
      isFrom: false,
    };
    SavingPotsActionCreator.handleMoveMoney(data);
    // PaymentsActionCreator.navigateToWebTask('WEB-OPEN-PAYMENTS');
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
    this.props.getPotPageHandleClick();
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_saving_goal_list_go_to_payments,
        event: 'click',
      }
    );
  }

  onDelete() {
    SavingPotsActionCreator.deletePotConnection(this.props.potDetailsData.id);
    SavingPotsActionCreator.getPotData();
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_saving_goal_viewer_delete_goal,
        event: 'click',
      }
    );
  }

  smClose() {
    this.setState({ showModal: false });
  }

  smShow() {
    this.setState({ showModal: true });
  }

  closeFaq() {
    this.setState({ faqFlag: false });
  }

  openFaq() {
    this.setState({ faqFlag: true });
  }

  render() {
    let content = this.props.content;
    const pot = this.props.potDetailsData;
    let targetDate = moment(pot.goalWhen).format('MMMM YYYY');
    const goalWhen = pot.goalWhen;
    const potBalance = parseFloat(pot.balance);
    const potGoal = parseFloat(pot.goalAmount);
    const potGoalCurrency = NumberUtils.appendCurrency('{}', potGoal);
    const potName = pot.name;
    const potScheduleValue = parseFloat(pot.monthlyContry);
    const potScheduleValueCurrency = NumberUtils.appendCurrency(
      '{}',
      potScheduleValue
    );
    let deleteModal;
    // todo global variable manipulation going on here!
    let displayHeader; // eslint-disable-line
    let message = (
      <div>
        <p>
          {content.savingPotDetailDeletMessage1}&nbsp;
          {content.savingPotDetailDeletMessage2}
        </p>
      </div>
    );
    let headerDoneButton;
    if (this.state.showModal) {
      deleteModal = (
        <DeleteModal
          content={content}
          onHide={this.smClose}
          onDelete={this.onDelete}
          message={message}
        />
      );
    }

    if (BrowserUtils.isMobileView()) {
      headerDoneButton = (
        <div>
          <button className="page-back" onClick={this.props.getPotPageMobile}>
            <span className="icon icon-page-back" />
            {content.back}
          </button>
        </div>
      );
    } else {
      headerDoneButton = (
        <div>
          <button
            className="page-back"
            onClick={this.props.getPotPageHandleClick}
          >
            <span className="icon icon-page-back" />
            {content.back}
          </button>
        </div>
      );
      displayHeader = <SiteHeader />;
    }
    let fromTop = '';
    if (BrowserUtils.isMobileView()) {
      fromTop = 'from-top';
    }
    return this.state.faqFlag ? (
      <div>
        <AnyQuestions {...this.props} closed={this.closeFaq} />
      </div>
    ) : (
      <div className={`main-container ${fromTop}`}>
        <div className={`potDetails sp ${this.props.accountClass}`}>
          <div className="savingpot_component__header row no-gutters">
            <div className="col-xs-4 text-left">{headerDoneButton}</div>
            <div className="col-xs-4 text-center">
              <div className="savingpot_component__header--title">
                {potName}
              </div>
            </div>
            <div className="col-xs-4 text-right" />
          </div>

          <div className="scroll-wrapper">
            <div className="potDetails--body content-wrapper">
              <MobileOverlay
                getHeaderClass={this.getHeaderClass}
                selectedTab="savingpotedit"
                content={this.props.content}
                openFaq={this.openFaq}
                _handleMoveMoney={this.handleMoveMoney}
                _editPot={this.editPot}
                _smShow={this.smShow}
              />
              <article className="row">
                <div className="col-sm-4 text-center">
                  <CircularProgress potBalance={potBalance} potGoal={potGoal} />
                </div>
                <div className="col-sm-8">
                  <h2>
                    {content.savingpotAimingBal}{' '}
                    <strong>{potGoalCurrency}</strong> {content.savingpotByBal}{' '}
                    <strong>{targetDate}</strong>{' '}
                    {content.savingpotByputtingAway}{' '}
                    <strong>{potScheduleValueCurrency}</strong>{' '}
                    {content.savingpotAmonth}.
                  </h2>
                  <div className="potMessages">
                    <PotDetailMessages
                      amountvalue={potScheduleValue}
                      goal={potGoal}
                      goalwhen={goalWhen}
                      balance={potBalance}
                      content={content}
                    />
                  </div>
                  <div className="detailButtons">
                    <button
                      type="button"
                      className="page-options opt-green border"
                      onClick={this.handleMoveMoney}
                    >
                      {' '}
                      <i className="icon icon-move" />{' '}
                      {content.savingPotMoveMoneyButton}{' '}
                    </button>
                    <button
                      type="button"
                      className="page-options opt-green border"
                      onClick={this.editPot}
                    >
                      {' '}
                      <i className="icon icon-edit" />{' '}
                      {content.savingPotEditPotButton}{' '}
                    </button>
                    <button
                      type="button"
                      className="page-options opt-green border"
                      onClick={this.smShow}
                    >
                      {' '}
                      <i className="icon icon-delete" />
                      {content.savingPotDeletePotButton}{' '}
                    </button>
                  </div>
                </div>
              </article>
            </div>
          </div>
          {deleteModal}
        </div>
      </div>
    );
  }
}

SavingPotDetail.propTypes = {
  potDetailsData: PropTypes.any.isRequired,
  getPotPageHandleClick: PropTypes.func,
  getSelectedAccountID: PropTypes.string,
  content: PropTypes.object,
  accountClass: PropTypes.string,
  getPotPageMobile: PropTypes.func,
};

export { SavingPotDetail };
